<template>
  <div
    class="flex justify-center gap-[60px]"
    :style="{
      'margin-top':
        topBarStore.removeTopBar || !topBarStore.showMainTopBar ? '0' : '56px',
      'padding-top': topBarStore.showWindowBar ? '132px' : '100px',
    }"
  >
    <ChoiceCard
      data-testid="premade-start"
      :header-title="$t('layout.start_template')"
      @click="openModla"
    >
      <template #icon>
        <svg
          width="134"
          height="180"
          viewBox="0 0 134 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="133"
            height="179"
            rx="3.5"
            stroke="currentColor"
            class="fill-gray-600"
          />
          <rect
            x="12.5"
            y="12.5"
            width="109"
            height="63"
            rx="1.5"
            stroke="currentColor"
            class="fill-gray-500"
          />
          <rect
            x="12.5"
            y="84.5"
            width="50"
            height="41"
            rx="1.5"
            stroke="currentColor"
            class="fill-gray-500"
          />
          <rect
            x="71.5"
            y="84.5"
            width="50"
            height="41"
            rx="1.5"
            stroke="currentColor"
            class="fill-gray-500"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 134C12.8954 134 12 134.895 12 136C12 137.105 12.8954 138 14 138H30C31.1046 138 32 137.105 32 136C32 134.895 31.1046 134 30 134H14ZM64 164C62.8954 164 62 164.895 62 166C62 167.105 62.8954 168 64 168H80C81.1046 168 82 167.105 82 166C82 164.895 81.1046 164 80 164H64ZM34 136C34 134.895 34.8954 134 36 134H44C45.1046 134 46 134.895 46 136C46 137.105 45.1046 138 44 138H36C34.8954 138 34 137.105 34 136ZM14 164C12.8954 164 12 164.895 12 166C12 167.105 12.8954 168 14 168H22C23.1046 168 24 167.105 24 166C24 164.895 23.1046 164 22 164H14ZM62 156C62 154.895 62.8954 154 64 154H72C73.1046 154 74 154.895 74 156C74 157.105 73.1046 158 72 158H64C62.8954 158 62 157.105 62 156ZM86 144C87.1046 144 88 144.895 88 146C88 147.105 87.1046 148 86 148H78C76.8954 148 76 147.105 76 146C76 144.895 76.8954 144 78 144H86ZM48 136C48 134.895 48.8954 134 50 134H94C95.1046 134 96 134.895 96 136C96 137.105 95.1046 138 94 138H50C48.8954 138 48 137.105 48 136ZM28 164C26.8954 164 26 164.895 26 166C26 167.105 26.8954 168 28 168H58C59.1046 168 60 167.105 60 166C60 164.895 59.1046 164 58 164H28ZM74 146C74 144.895 73.1046 144 72 144H28C26.8954 144 26 144.895 26 146C26 147.105 26.8954 148 28 148H72C73.1046 148 74 147.105 74 146ZM58 154C59.1046 154 60 154.895 60 156C60 157.105 59.1046 158 58 158H14C12.8954 158 12 157.105 12 156C12 154.895 12.8954 154 14 154H58ZM98 136C98 134.895 98.8954 134 100 134H108C109.105 134 110 134.895 110 136C110 137.105 109.105 138 108 138H100C98.8954 138 98 137.105 98 136ZM86 164C84.8954 164 84 164.895 84 166C84 167.105 84.8954 168 86 168H94C95.1046 168 96 167.105 96 166C96 164.895 95.1046 164 94 164H86ZM24 146C24 144.895 23.1046 144 22 144H14C12.8954 144 12 144.895 12 146C12 147.105 12.8954 148 14 148H22C23.1046 148 24 147.105 24 146ZM86 154C87.1046 154 88 154.895 88 156C88 157.105 87.1046 158 86 158H78C76.8954 158 76 157.105 76 156C76 154.895 76.8954 154 78 154H86Z"
            fill="currentColor"
          />
        </svg>
      </template>
    </ChoiceCard>
    <ChoiceCard
      data-testid="empty-start"
      :header-title="$t('layout.start_scratch')"
      @click="$emit('setChoice')"
    >
      <template #icon>
        <svg
          width="134"
          height="180"
          viewBox="0 0 134 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="133"
            height="179"
            rx="3.5"
            stroke="currentColor"
          />
          <rect
            x="12"
            y="12"
            width="110"
            height="34"
            stroke="currentColor"
            stroke-linecap="square"
            stroke-linejoin="round"
            stroke-dasharray="4 4"
            class="fill-gray-600"
          />
          <rect
            x="12"
            y="54"
            width="51"
            height="34"
            stroke="currentColor"
            stroke-linecap="square"
            stroke-linejoin="round"
            stroke-dasharray="4 4"
            class="fill-gray-600"
          />
          <rect
            x="71"
            y="54"
            width="51"
            height="34"
            stroke="currentColor"
            stroke-linecap="square"
            stroke-linejoin="round"
            stroke-dasharray="4 4"
            class="fill-gray-600"
          />
          <rect
            x="12"
            y="96"
            width="110"
            height="72"
            stroke="currentColor"
            stroke-linecap="square"
            stroke-linejoin="round"
            stroke-dasharray="4 4"
            class="fill-gray-600"
          />
          <rect
            x="12"
            y="96"
            width="55"
            height="72"
            stroke="currentColor"
            stroke-linecap="square"
            stroke-linejoin="round"
            stroke-dasharray="4 4"
            class="fill-gray-600"
          />
        </svg>
      </template>
    </ChoiceCard>
  </div>
</template>

<script setup lang="ts">
  import ChoiceCard from "@/layout/StartChoice/ChoiceCard/ChoiceCard.vue";
  import { useTopBarStore } from "@/stores/topBar";

  defineEmits<{
    (e: "setChoice"): void;
  }>();

  const topBarStore = useTopBarStore();

  function openModla() {
    window.$event.emit("openTemplatePicker");
  }
</script>

<style lang="scss"></style>
